import React, { useState, useContext, useEffect } from 'react'
import cx from 'classnames'
import moment from 'moment';

import { MediaQueryContext } from '@arrive/responsive-provider';

import { LocationSearchType } from 'sharedTypes/location/locationTypes';
import CitySearch from 'components/BookingModal/BookingModalCitySearch';
import DatePicker, { formatSingleDate, DatePickerTextEntry } from '@arrive/date-picker';
import TimeEntry from '@arrive/time-entry';
import TextEntry from '@arrive/text-entry';

import styles from './BookingModal.scss';

interface Props {
  emptyCity: LocationSearchType;
  setEmptyCity: (emptyCity: LocationSearchType) => void;
  emptyDate: moment.Moment;
  setEmptyDate: (emptyDate: moment.Moment) => void;
  emptyTime: string;
  setEmptyTime: (emptyTime: string) => void;
  sectionIsActive: boolean;
  showDateAndTime: boolean;
  pickupLocationIANACode: string;
}

export default function BookingModalEmptyCity({ emptyCity, setEmptyCity, emptyDate, setEmptyDate, emptyTime, setEmptyTime, sectionIsActive, showDateAndTime, pickupLocationIANACode }: Props) {
  const currentMediaTypes = useContext(MediaQueryContext);

  const [dateStringValue, setDateStringValue] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);

  const emptyLocationLabel = emptyCity ? `${emptyCity?.CityName?.toLowerCase()}, ${emptyCity?.CityState}` : 'Empty Location';

  useEffect(() => {
    if (emptyDate && (currentMediaTypes.xs || currentMediaTypes.sm)) {
      setDateStringValue(formatSingleDate(emptyDate, 'MM/DD/YYYY'))
    }
  }, [emptyDate, currentMediaTypes.xs, currentMediaTypes.sm])

  return (
    <div className={cx(styles.listContent, !sectionIsActive && styles.disabledContent)}>
      <div className={styles.header}>Where will you be empty?</div>
      <div className={styles.subHeader}>This helps us validate if the current pickup appointment can be met.</div>
      <div className={styles.searchContainer}>
        {sectionIsActive ?
          <CitySearch
            selectedCity={emptyCity}
            setSelectedCity={setEmptyCity}
          /> :
          <TextEntry
            data-testid="emptyLocationInput"
            classes={{ inputWrapper: cx(styles.emptyCitySearchInputWrapper), container: styles.emptyCityContainerResponsive }}
            onChange={() => {
              //no op
            }}
            disabled
            label={emptyLocationLabel}
          />
        }

        {showDateAndTime &&
          <div className={styles.dateAndTimeContainer}>
            <div className={styles.timeDateResponsiveContainerWrapper}>
              <DatePicker
                className={styles.datePicker}
                disabled={!sectionIsActive}
                onApplyClick={(newDate: moment.Moment) => {
                  setEmptyDate(newDate)
                  setDateStringValue(formatSingleDate(newDate, 'MM/DD/YYYY'))
                }}
                date={emptyDate}
                keepOpenOnDateSelect={currentMediaTypes.xs}
                showPopover={showDatePicker}
                setShowPopover={setShowDatePicker}
                useApplyButtonBar={currentMediaTypes.xs}
                popoverClasses={{ contentContainerClass: styles.datePopover }}
                screenSizeSmall={currentMediaTypes.xs}
                orientation={currentMediaTypes.xs ? 'vertical' : 'horizontal'}
              >
                <DatePickerTextEntry
                  classes={{ inputWrapper: styles.textEntry, container: styles.dateTimeResponsiveContainer }}
                  disabled={!sectionIsActive}
                  label="Empty Date"
                  setShowDatePicker={setShowDatePicker}
                  showDatePicker={showDatePicker}
                  setDateStringValue={setDateStringValue}
                  dateStringValue={dateStringValue}
                  setDate={setEmptyDate}
                  date={emptyDate}
                  dateIANACode={pickupLocationIANACode}
                />
              </DatePicker>
            </div>
            <div className={styles.timeDateResponsiveContainerWrapper}>
              <TimeEntry
                classes={{ inputWrapper: styles.textEntry, container: cx(styles.dateTimeResponsiveContainer, styles.timeEntry) }}
                isDisabled={!sectionIsActive}
                value={emptyTime}
                setTime={setEmptyTime}
                label={'Empty Time'}
              />
            </div>
          </div>
        }

      </div>
    </div>
  )
}
